export default __webpack_public_path__ + "static/media/inBuilding.becd1465.svg";